"use client";

import { WcTypography } from "@bpipartners/webui";
import { useTranslations } from "next-intl";
import React from "react";

export const EmptyDataSetFallback = () => {
  const t = useTranslations();

  return (
    <WcTypography sx={{ textAlign: "center", color: "#9e9e9e", fontSize: "13px", padding: "16px 0" }}>
      {t("common.noData")}
    </WcTypography>
  );
};
